var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import Input from '../../components/Input';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import translate from '../../lib/utils/translate';

var SignUpIssues = function SignUpIssues(_ref) {
  var issues = _ref.issues;
  return React.createElement(
    'div',
    null,
    React.createElement(Translate, {
      defaultMessage: 'sign up issues',
      tagName: 'p',
      id: 'label.sign_up_issues'
    }),
    React.createElement(
      'ul',
      null,
      issues.map(function (i) {
        return React.createElement(
          'li',
          { key: i },
          React.createElement(Translate, {
            defaultMessage: 'sign us issue',
            id: 'label.sign_up_issue.' + i
          })
        );
      })
    ),
    React.createElement(
      'a',
      {
        onClick: function onClick(e) {
          e.preventDefault();
          window.$zopim.livechat.window.show();
        },
        className: 'button primary' },
      React.createElement(Translate, { defaultMessage: 'live chat', id: 'start.live-chat' })
    )
  );
};

var ActivationStep = function (_Component) {
  _inherits(ActivationStep, _Component);

  function ActivationStep() {
    _classCallCheck(this, ActivationStep);

    return _possibleConstructorReturn(this, (ActivationStep.__proto__ || Object.getPrototypeOf(ActivationStep)).apply(this, arguments));
  }

  _createClass(ActivationStep, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          phone = _props.phone,
          _onBlur = _props.onBlur,
          errors = _props.errors,
          onSubmit = _props.onSubmit,
          resendActivateCode = _props.resendActivateCode,
          intl = _props.intl,
          signUpIssues = _props.signUpIssues,
          showPlaceholder = _props.showPlaceholder,
          showLabel = _props.showLabel;


      if (signUpIssues && signUpIssues.hasIssues) return React.createElement(SignUpIssues, { issues: signUpIssues.issues });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'form',
          { className: 'Step4 form activate-form', onSubmit: onSubmit },
          React.createElement(
            'div',
            null,
            React.createElement(
              'p',
              null,
              translate({ id: 'label.activation_code_received' }, intl),
              ' ',
              phone
            )
          ),
          React.createElement(
            'div',
            null,
            React.createElement(Input, {
              className: 'layout-item-full-width',
              placeholder: showPlaceholder && translate({ id: 'label.activation_code' }, intl),
              title: showLabel && translate({ id: 'label.activation_code' }, intl),
              name: 'activation_code',
              onBlur: function onBlur(value) {
                return _onBlur('activation_code', value);
              },
              error: errors.activation_code && translate({ id: errors.activation_code }, intl),
              autoComplete: 'one-time-code'
            })
          ),
          React.createElement('div', { className: 'divider' }),
          React.createElement(
            'button',
            {
              className: 'button primary active-button layout-item-full-width',
              type: 'submit' },
            translate({ id: 'action.button.activate_account' }, intl)
          )
        ),
        React.createElement(
          'div',
          { className: 'resend-button' },
          React.createElement(
            'button',
            { className: 'button tertiary wide', onClick: resendActivateCode },
            translate({ id: 'action.resend_activation_code' }, intl)
          )
        )
      );
    }
  }]);

  return ActivationStep;
}(Component);

ActivationStep.propTypes = {
  /** Users Phone number */
  phone: PropTypes.string,
  /** When user moves focus from input field */
  onBlur: PropTypes.func,
  /** Error object */
  errors: PropTypes.object,
  /** Submits the form */
  onSubmit: PropTypes.func,
  /** Resends the activation code */
  resendActivateCode: PropTypes.func,
  /** Translation object */
  intl: PropTypes.object,
  /** Issues object containing a list of issues displayed when issues occur */
  signUpIssues: PropTypes.object,
  /** Boolean for showing placeholder for input fields */
  showPlaceholder: PropTypes.bool,
  /** Boolean for showing label for input fields */
  showLabel: PropTypes.bool
};


var rules = {
  activation_code: [[require, 'error.empty.activation_code']]
};

export default compose(WithValidation(rules), injectIntl)(ActivationStep);